import React from 'react';
import { BrowserRouter,Routes, Route } from 'react-router-dom';
import Home from './Components/Home/Home';
import Contact from './Components/Contact/Contact';
// import About from './Components/About/About';
import Header from './Components/Header/Header';
import Footer from './Components/Footer/Footer';
import Riddles from './Components/Riddles/Riddles';
import VersusComputer from './Components/TicTacToe/VersusComputer';
import VersusHuman from './Components/TicTacToe/VersusHuman';
import Memory from './Components/Memory/Memory';
import MemoryNumbers from './Components/Memory/Numbers/MemoryNumbers';
import MemoryColors from './Components/Memory/Colors/MemoryColors';
import MemoryAnimals from './Components/Memory/Animals/MemoryAnimals';
import './App.css';


export default function App() {
  return (
    <BrowserRouter>
      <Header/>
      <Routes>
        <Route exact path='/' element={< Home />}></Route>
        <Route exact path='/contact' element={<Contact />}></Route>
        {/* <Route exact path='/a-propos' element={< About />}></Route> */}
        <Route exact path='/devinettes' element={< Riddles />}></Route>
        <Route exact path='/morpion-contre-ordinateur' element={< VersusComputer />}></Route>
        <Route exact path='/morpion-contre-adversaire' element={<VersusHuman />}></Route>
        <Route exact path='/memory' element={<Memory />}></Route>
        <Route exact path='/memory-chiffres' element={<MemoryNumbers />}></Route>
        <Route exact path='/memory-couleurs' element={<MemoryColors />}></Route>
        <Route exact path='/memory-animaux' element={<MemoryAnimals />}></Route>
      </Routes>
      <Footer/>
    </BrowserRouter>
  );
}
